import type { Category } from '@opensentry/shared';
import {
  Activity,
  Biohazard,
  CloudRain,
  Flag,
  Flame,
  type LucideIcon,
  Swords,
  TriangleAlert,
} from 'lucide-react';

export const CATEGORY_ICON: Record<Category, LucideIcon> = {
  conflict: Swords,
  seismic: Activity,
  wildfire: Flame,
  weather: CloudRain,
  disaster: TriangleAlert,
  health: Biohazard,
  advisory: Flag,
};
